import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class PortalMenuService {
    async getMenuCategories() {
        const response = await axios.get(Config.apiBasePath + '/getPortalMenuType', {headers: authHeader()});
        // const response = await axios.get(Config.apiBasePath + '/getPortalMenuType', { headers: authHeader() });
        return response;
    }

    async getPortalMenus(id) {
        const response = await axios.get(Config.apiBasePath + '/navbar/getAllNavbarMenus/' + id, {headers: authHeader()});
        // const response = await axios.get(Config.apiBasePath + '/navbar/getAllNavbarMenus/' + id, { headers: authHeader() });
        return response;
    }

    async getSubCategories() {
        const response = await axios.get(Config.apiBasePath + '/getAllCategoryWiseSubcategories', {headers: authHeader()});
        return response;
    }

    async getElements() {
        const response = await axios.get(Config.apiBasePath + '/getAllCategoryWiseElements', {headers: authHeader()});
        return response;
    }

    async saveMenuItem(data) {
        const response = await axios.post(Config.apiBasePath + '/navbar/saveNavbarMenu', data, {headers: authHeader()});
        return response;
    }

    async updateMenuItem(data) {
        const response = await axios.post(Config.apiBasePath + '/navbar/updateNavbarMenus', data, {headers: authHeader()});
        return response;
    }

    async deleteMenuItem(data) {
        const response = await axios.post(Config.apiBasePath + '/navbar/deleteNavbarMenu', data, {headers: authHeader()});
        return response;
    }

    async deleteMenuItemById(id) {
        const response = await axios.get(Config.apiBasePath + '/navbar/deletePortalNavbarMenu/' + id, {headers: authHeader()});
        return response;
    }
}

export default new PortalMenuService();